import { createContext, useContext } from 'react';

export type TeamChatView = {
  readonly viewerId: number;
  readonly ownerId: number;
  readonly ownerName: string;
};

export const TeamChatViewContext = createContext<TeamChatView | null>(null);

export const useTeamChatView = (): TeamChatView | null =>
  useContext(TeamChatViewContext);
